import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface Company {
  companyCode: string;
  companyName: string;
}

export interface dashboardFilter {
  companyList: Company[];
  regionIdList: number[];
  regionList: any[];
  countryList: any[];
  viewType: number;
  pageUrl: string;
  portType: string; 
}

@Injectable({
  providedIn: 'root'
})
/**
 * @class SharedFilterService
 * @description Service to manage and share filter states across the application.
 * 
 * @property {BehaviorSubject<any[]>} companyListSubject - Subject to hold the list of companies.
 * @property {Observable<any[]>} companyList$ - Observable to subscribe to the company list.
 * 
 * @property {BehaviorSubject<dashboardFilter>} dashboardFilterSubject - Subject to hold the dashboard filter state.
 * @property {Observable<dashboardFilter>} dashboardFilter$ - Observable to subscribe to the dashboard filter state.
 * 
 * @property {BehaviorSubject<string[]>} selectedCompaniesSubject - Subject to hold the selected companies.
 * @property {Observable<string[]>} selectedCompanies$ - Observable to subscribe to the selected companies.
 * 
 * @property {BehaviorSubject<boolean>} applyFilterSubject - Subject to trigger filter application.
 * @property {Observable<boolean>} applyFilter$ - Observable to subscribe to the filter application trigger.
 * 
 * @method setCompanyList
 * @description Sets the company list and updates the selected companies.
 * @param {Company[]} companyList - The list of companies to set.
 * 
 * @method updateSelectedCompanies
 * @description Updates the selected companies.
 * @param {string[]} selectedCompanies - The list of selected company codes.
 * 
 * @method updateDashboardFilter
 * @description Updates the dashboard filter state.
 * @param {Partial<dashboardFilter>} filter - The partial filter object to update.
 * 
 * @method triggerFilterApis
 * @description Triggers the filter application process.
 */
export class SharedFilterService {

  private isFirstLoad = true;
  public portParam = 'origin';

  private portParamSubject = new BehaviorSubject<string>('');
  public portParam$ = this.portParamSubject.asObservable();

  private filterRequestSubject = new BehaviorSubject<any>('');
  public filterRequest$ = this.filterRequestSubject.asObservable();

  private filterRequestSubjectListView = new BehaviorSubject<any>('');
  filterRequestListView$:Observable<any> = this.filterRequestSubjectListView.asObservable();

 



  private viewTypeSubject = new BehaviorSubject<number>(0);
  public viewType$ = this.viewTypeSubject.asObservable();
  // Company List
  private companyListSubject = new BehaviorSubject<any[]>([]);
  companyList$ = this.companyListSubject.asObservable();

  private dashboardFilterSubject = new BehaviorSubject<dashboardFilter>({
    companyList: [],
    regionIdList: [],
    regionList: [],
    countryList: [],
    viewType: 0, 
    pageUrl:'',
    portType: ''
  });
  dashboardFilter$ = this.dashboardFilterSubject.asObservable();

  private selectedCompaniesSubject = new BehaviorSubject<string[]>([]);
  selectedCompanies$ = this.selectedCompaniesSubject.asObservable();

  private applyFilterSubject = new BehaviorSubject<boolean>(false);
  applyFilter$ = this.applyFilterSubject.asObservable();

  private isInitializedSubject = new BehaviorSubject<boolean>(false);
  public isInitialized$ = this.isInitializedSubject.asObservable();
  
  // Method to signal initialization is complete
  markAsInitialized() {
    this.isInitializedSubject.next(true);
  }

  updateViewType(viewType: number) {
    const currentFilter = this.dashboardFilterSubject.value;
    const updatedFilter = { ...currentFilter, viewType };
    this.dashboardFilterSubject.next(updatedFilter);
  }

  // Company List
  setCompanyList(companyList: Company[]) {
    this.companyListSubject.next(companyList);
    const allCompanyCodes = companyList.map(company => company.companyCode);
    this.selectedCompaniesSubject.next([]);
  }
  // Selected Companies
  updateSelectedCompanies(selectedCompanies: string[]) {
    this.selectedCompaniesSubject.next(selectedCompanies);
  }


  // Dashboard Filter
  updateDashboardFilter(filter: Partial<dashboardFilter>) {
    const currentFilter = this.dashboardFilterSubject.value;
    const updatedFilter = { ...currentFilter, ...filter };
    this.dashboardFilterSubject.next(updatedFilter);
  }
  // Trigger Filter APIs
  triggerFilterApis() {
    this.applyFilterSubject.next(true);
  }

  shouldSkipFirstEmission(): boolean {
    const firstLoadKey = 'isFirstLoad';
    const isFirstLoad = sessionStorage.getItem(firstLoadKey);

    console.log('Session Storage isFirstLoad:', isFirstLoad);

    if (isFirstLoad === null || isFirstLoad === 'true') {
        // If first time visiting Home, skip first emission
        sessionStorage.setItem(firstLoadKey, 'false'); // Set to false after first load
        return true;
    }

    return false; // Don't skip for subsequent visits
  }

  resetFirstLoadFlag() {
    this.isFirstLoad = true; // Reset on logout or refresh
  }

updatePortType(portType: string | string[], override?: boolean) {
    if (Array.isArray(portType)) {
        this.portParam = portType.length === 2 ? "both" : portType[0];
    } else {
        this.portParam = portType;
    }
    const currentFilter = this.dashboardFilterSubject.value;
    const updatedFilter = { ...currentFilter, portType: this.portParam };
    this.dashboardFilterSubject.next(updatedFilter);

}

updateFilterrequest (event:any) {
  this.filterRequestSubject.next(event);
}

updateFilterRequestListView (event:any) {
  event.isTrue = true;
  this.filterRequestSubjectListView.next(event);
}

  selectedFilters: any = {};  // Filter state
  selectedCompanies: string[] = [];  // Selected companies
  filterVisibility: boolean = false;  // Filter visibility state
  resetFilters() {
    // Reset all filter properties
    this.selectedFilters = {};  // Clear the filters
    this.selectedCompanies = [];  // Clear selected companies
    this.filterVisibility = false;  // Reset visibility
    this.portParam = '';  // Reset port param

    
    this.filterRequestSubject.next(this.selectedFilters);  
  }
  
}
 

